import { AmberHoc, AmberHocProps } from '../../../util';
import {
  BinEventFragmentFragment as Result,
  CreateBinEventMutationVariables as Variables,
  GetGrainBinEventsDocument,
  GetGrainBinEventsQuery,
  GetGrainBinEventsQueryVariables,
  withCreateBinEvent as HOC,
} from '../__generated';
import { GraphQLErrors } from './error';

export type WithCreateBinEventHocChildProps = {
  createBinEvent: (variables: Variables) => Promise<Result[]>;
};
export const withCreateBinEventHoc: AmberHoc<{}, WithCreateBinEventHocChildProps> = (component) =>
  HOC<
    AmberHocProps<{}, WithCreateBinEventHocChildProps, typeof component>,
    WithCreateBinEventHocChildProps
  >({
    options: { errorPolicy: 'all' },
    props: (props) => {
      const { mutate } = props;
      return {
        createBinEvent: async (variables) => {
          if (!mutate) {
            throw new Error('Unexpected UI error');
          }
          const result = await mutate({
            variables,
            update: (proxy, { data, errors }) => {
              if (errors || !data) {
                return;
              }
              const { createBinEvent: result } = data;
              if (!result) {
                return;
              }
              proxy.writeQuery<GetGrainBinEventsQuery, GetGrainBinEventsQueryVariables>({
                query: GetGrainBinEventsDocument,
                data: { __typename: 'Query', latest_grain_bin_events: result },
                variables: { grain_bin_id: variables.grain_bin_id },
              });
            },
          });
          if (!result) {
            throw new Error('Unexpected server response');
          }
          const { errors, data } = result;
          if (errors) {
            throw new GraphQLErrors(errors);
          }
          if (!data) {
            throw new Error('Unexpected server response');
          }
          return data.createBinEvent || [];
        },
      };
    },
  })(component as any);
